import * as React from 'react';
import { connect } from 'react-redux';
import { AdminReportingProfiles } from '../../components/pages/survey-admin/AdminReportingProfiles';
import { IApplicationState } from '../../store';
import { SurveyHelper } from '../../utilities';

export const ReportingProfilesPage: React.ComponentType<{ surveyId: number }> = connect((state: IApplicationState) => ({
	distributionType: SurveyHelper.getDistributionType(state.surveyAdmin.audiences),
	surveyAdminSummary: state.surveyAdmin.surveyAdminSummary,
}))(AdminReportingProfiles);
